import { NavigateFunction } from "react-router-dom";

export const CONTACT_SECTION_ID = "contact";
export const CONTACT_ROUTE = "/home";

const CONTACT_HASH = `#${CONTACT_SECTION_ID}`;

const isMobileViewport = () =>
  typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;

const getContactScrollOffset = () => (isMobileViewport() ? 112 : 88);

export const scrollToSectionById = (
  sectionId: string,
  behavior: ScrollBehavior = "smooth"
): boolean => {
  if (typeof window === "undefined") return false;
  const target = document.getElementById(sectionId);
  if (!target) return false;

  const targetTop =
    target.getBoundingClientRect().top + window.scrollY - getContactScrollOffset();

  window.scrollTo({ top: Math.max(0, targetTop), behavior });
  return true;
};

export const shouldScrollToContactFromLocation = (
  hash?: string,
  search?: string
): boolean => {
  if (hash === CONTACT_HASH) return true;

  if (!search) return false;
  const query = new URLSearchParams(search);
  return query.get("scrollTo") === CONTACT_SECTION_ID;
};

export const navigateToContactSection = (
  navigate: NavigateFunction,
  pathname: string
): void => {
  const isHome = pathname === "/" || pathname === "/home";

  if (isHome) {
    const didScroll = scrollToSectionById(CONTACT_SECTION_ID);
    if (didScroll) {
      if (window.location.hash !== CONTACT_HASH) {
        window.history.replaceState(null, "", CONTACT_HASH);
      }
      return;
    }

    navigate(`${CONTACT_ROUTE}${CONTACT_HASH}`);
    return;
  }

  navigate(`${CONTACT_ROUTE}${CONTACT_HASH}`);
};
